import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'

export const MainIngredients = ({ currentFormular, ingredients, t }) => (
  <React.Fragment>
    {currentFormular && (
      <span className={clsx('pdp__formular-ingredients', Typo.subtitle2)}>
        {`${currentFormular} - ${t('Ingredients')}`}
      </span>
    )}
    <span className={Typo.body2}>{ingredients}.</span>
  </React.Fragment>
)

export const FreeFromIngredients = ({ ingredients, t }) => (
  <div className="pdp__free-from-ingredients">
    <span className={clsx('pdp__formular-ingredients', Typo.subtitle2)}>
      {hasLocizeTranslation(t, 'FREE_FROM', 'Free From')}
    </span>
    <span className={Typo.body2}>{ingredients}.</span>
  </div>
)

const ProductIngredients = ({ product, t }) => {
  const { id_product, ingredients, variations } = product

  const currentFormular = variations?.find(
    (attr) => attr.id_product === id_product,
  )
  const freeFrom = ingredients?.free_from

  return (
    <React.Fragment>
      <MainIngredients
        currentFormular={currentFormular?.name}
        ingredients={ingredients?.main}
        t={t}
      />
      {freeFrom && <FreeFromIngredients ingredients={freeFrom} t={t} />}
    </React.Fragment>
  )
}

MainIngredients.propTypes = {
  ingredients: PropTypes.string.isRequired,
  currentFormular: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

FreeFromIngredients.propTypes = {
  ingredients: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

ProductIngredients.defaultProps = {
  product: {
    variations: [{ name: 'Formular Name' }],
    ingredients: {
      main: '',
      free_from: '',
    },
  },
}

ProductIngredients.propTypes = {
  product: PropTypes.shape({
    id_product: PropTypes.number,
    ingredients: PropTypes.shape({
      main: PropTypes.string,
      free_from: PropTypes.string,
    }),
    variations: PropTypes.arrayOf(
      PropTypes.shape({
        id_product: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
  }),
  t: PropTypes.func.isRequired,
}

export default withI18next()(ProductIngredients)
